import { COUNT_FILE_ERROR, COUNT_FILE_SUCCESS, COUNT_FILE_POST_ERROR} from "../actions/types";

export default (state = { error: "", success: "", isSwitchSnackbarOn: false }, action) => {
    switch (action.type) {
        case COUNT_FILE_ERROR:
            return {
                ...state,
                error: COUNT_FILE_ERROR,
                success: state.success,
            };
        case COUNT_FILE_SUCCESS:
            return {
                ...state,
                error: state.error,
                success: action.payload,
                count: action.count,
            };
        case COUNT_FILE_POST_ERROR:
            return {
                ...state,
                error: state.error,
                success: action.payload,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/countFileReducer.js